import Vue from 'vue'
import Vuex from 'vuex'
import { randomBtw,shuffleArray } from '../tools/helpers'

const block3 = ['3.1-intro,3.1','3.2-intro,3.2','3.3-intro,3.3']

Vue.use(Vuex)

export default new Vuex.Store({
  state: { 
    apiUri: "https://misc.epicalab.com/iat-results/v1/graphql",
    // apiUri: " http://35.205.180.84:8080/v1/graphql",
    userData: {},
    currentCard: 0,
    userId: '',
    age: 0,
    numEvents: 0,
    genderId: 0,
    studiesId: 0,
    sessionId: 0,
    results: [],
    timeLimit: 12000, // milliseconds
    interBlockTimeLimit: 300,
    warningTimeLimit: 4000,
    serie: randomBtw(1,10)%2,
    randomBlock3: shuffleArray(block3).map(el => el.split(',')).flat()
  },
  getters: {
    optionsBlocks (state) {
      if(state.option >= 5)
        return state.optionA
      else  
        return state.optionB
    }
  },
  mutations: {
    nextCard(state){
      if (state.currentCard <10)
        state.currentCard++
    },
    setGender(state, v){
      state.genderId = v
    },
    setStudies(state, v){
      state.studiesId = v
    },
    setAge(state, v){
      state.age = v
    },
    setNumEvents(state, v){
      state.numEvents = v
    },
    setUserId(state, v){
      state.userId = v
    },
    setSessionId(state, v){
      state.sessionId = v
    },
    addResults(state, v){
      state.results = state.results.concat(v)
    },
    setUserData(state, v){
      state.userData = v
    }
  },
  actions: {
    nextCard ({ commit }) {
      commit('nextCard')
    },
    setGender({ commit }, v) {
      commit('setGender',v)
    },
    setStudies({ commit }, v) {
      commit('setStudies',v)
    },
    setAge({ commit }, v) {
      commit('setAge',v)
    },
    setNumEvents({ commit }, v) {
      commit('setNumEvents',v)
    },
    setUserId({ commit }, v) {
      commit('setUserId',v)
    },
    setSessionId({ commit }, v) {
      commit('setSessionId',v)
    },
    addBlockResults({ commit }, v) {
      commit('addResults',v)
    },
    setUserData({ commit }, v) {
      commit('setUserData',v)
    }
  },
  modules: {
  }
})
